import { render, staticRenderFns } from "./veStuMoralActiveMy.vue?vue&type=template&id=2453c06e&scoped=true"
import script from "./veStuMoralActiveMy.vue?vue&type=script&lang=js"
export * from "./veStuMoralActiveMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453c06e",
  null
  
)

export default component.exports